"use strict";

module.exports = /*@ngInject*/function ($resource, $http, $window, $location, ConfigService, ENV, ORIGINAL_URL_STORAGE_KEY) {
  var storageKey = ORIGINAL_URL_STORAGE_KEY;
  var _ConfigService$getCon = ConfigService.getConfig(),
    BRAND_URL = _ConfigService$getCon.BRAND_URL;
  var service = {
    tenant: {},
    referrer: '',
    initialize: function initialize() {
      if ($location.url().indexOf('/public/report/') !== -1) {
        return Promise.resolve({});
      }
      if (!service.tenant.brand) {
        return service.fetchBrand();
      }
      return Promise.resolve(service.tenant);
    },
    fetchBrand: function fetchBrand() {
      return $http.get("".concat(BRAND_URL, "/api")).then(function (response) {
        service.tenant = response.data;
        return Promise.resolve(service.tenant);
      });
    },
    restoreOriginalUrl: function restoreOriginalUrl() {
      var url = $window.sessionStorage.getItem(storageKey);
      if (url) {
        $window.sessionStorage.removeItem(storageKey);
        // eslint-disable-next-line no-param-reassign
        $window.location.href = url;
      }
    }
  };
  return service;
};